import { Observable, of as observableOf } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, share } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CardSvgStoreService {
  private _svg: string;

  constructor(private http: HttpClient) {}

  public fetchSvg(url: string): Observable<string> {
    if (this._svg) {
      // return cached svg if present
      return observableOf(this._svg);
    } else {
      // else run a real XHR request
      return this.http.get(url, { responseType: 'text' }).pipe(
        map((res: any) => {
          this._svg = res;
          return res;
        }),
        share()
      );
    }
  }
}
